<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-with-title heading-container-single heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">ALSO BY JANE HEAFIELD</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="underline"><span class="smallcaps">The Yorkshire Murder Thrillers</span></span></p>
<p class="subsq also-by-content"><span class="content-external-link">Dead Cold (Book 1)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Cold Blood (Book 2)</span></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/ColdHeartJH" target="_blank">Cold Heart (Book 3)</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="content-external-link">Don’t Believe Her</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="content-external-link">Her Dark Past</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-jane-heafield.vue?9a47841e